const API_BASE = process.env.REACT_APP_API_URL;
const ROL_URL = `${API_BASE}Rol`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const headers = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export async function getRoles() {
  const res = await fetch(ROL_URL, {
    headers: getAuthHeaders()
  });
  return await res.json();
}

export async function createRol(values) {
  try {
    await fetch(ROL_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function editRol(id, values) {
  try {
    await fetch(`${ROL_URL}/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({
        nombre: values.nombre,
        estado: Number(values.estado)
      })
    });
    return true;
  } catch {
    return false;
  }
}

export async function deleteRol(id) {
  try {
    await fetch(`${ROL_URL}/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders()
    });
    return true;
  } catch {
    return false;
  }
}

export async function getPermisosByRol(idRol) {
  const url = `${API_BASE}roles/${idRol}/permisos`;
  const res = await fetch(url, {
    headers: getAuthHeaders()
  });
  if (!res.ok) {
    // Intenta leer el texto para debuggear el error
    const errorText = await res.text();
    console.error('Error al obtener permisos del rol:', errorText);
    return [];
  }
  let data;
  try {
    data = await res.json();
  } catch (e) {
    console.error('Respuesta no es JSON:', e);
    return [];
  }
  // Normaliza el id para que sea id_permiso
  return data.map(p => ({
    ...p,
    id_permiso: p.id_permiso ?? p.id_permisos // usa el que exista
  }));
}

export async function assignPermisosToRol(idRol, permisosIds) {
  const url = `${API_BASE}roles/${idRol}/permisos`;
  // Envía una petición por cada permiso
  const results = await Promise.all(
    permisosIds.map(async idPermiso => {
      const res = await fetch(url, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify({ permisos_id: Number(idPermiso) })
      });
      return res.ok;
    })
  );
  // Retorna true solo si todas las asignaciones fueron exitosas
  return results.every(ok => ok);
}

export async function removePermisosFromRol(idRol, permisosIds) {
  // Envía una petición DELETE por cada permiso a eliminar, usando la ruta correcta
  const results = await Promise.all(
    permisosIds.map(async idPermiso => {
      const url = `${API_BASE}roles/${idRol}/permisos/${Number(idPermiso)}`;
      const res = await fetch(url, {
        method: 'DELETE',
        headers: getAuthHeaders()
      });
      return res.ok;
    })
  );
  return results.every(ok => ok);
}
